import * as React from 'react';
import Drawer from '@mui/material/Drawer';
import { Box } from '@mui/material';

export default function DrawerWidget({ width, open, onClose, children }) {
  return (
    <React.Fragment>
      <Drawer
        anchor="right"
        open={open}
        onClose={() => onClose(false)}
        sx={{ zIndex: 1260 }}
      >
        <Box sx={{ width: width ?? '35vw', p: 2 }} role="presentation">
          {children}
        </Box>
      </Drawer>
    </React.Fragment>
  );
}
